import React from 'react'
import { ShareAPIPolyfillData } from 'share-api-polyfill'

// @types/share-api-polyfillにpinterestが定義されていないバグがあるため追加
interface ShareAPIPolyfillOptions {
  copy?: boolean | undefined
  email?: boolean | undefined
  print?: boolean | undefined
  sms?: boolean | undefined
  messenger?: boolean | undefined
  facebook?: boolean | undefined
  whatsapp?: boolean | undefined
  twitter?: boolean | undefined
  linkedin?: boolean | undefined
  telegram?: boolean | undefined
  skype?: boolean | undefined
  pinterest?: boolean | undefined
  language?: string | undefined
}

declare global {
  interface Navigator {
    share(
      data?: ShareAPIPolyfillData,
      configuration?: ShareAPIPolyfillOptions
    ): Promise<void>
  }
}

export const useShare = () => {
  React.useEffect(() => {
    require('share-api-polyfill')
  }, [])

  const handleClickShareSNS = React.useCallback(
    async (options: ShareAPIPolyfillData) => {
      try {
        await window.navigator.share(options, {
          copy: true,
          email: true,
          print: false,
          sms: true,
          messenger: false,
          facebook: true,
          whatsapp: false,
          twitter: true,
          linkedin: false,
          telegram: false,
          skype: false,
          pinterest: false,
          language: 'ja',
        })
      } catch (error) {
        throw new Error()
      }
    },
    []
  )

  return {
    onClickShareSNS: handleClickShareSNS,
  }
}
